import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './auth';
import Login from './Login';
import Dashboard from './Dashboard';
import Servers from './Servers';
import ServerDetail from './ServerDetail';
import Alerts from './Alerts';
import SettingsPage from './Settings';
import TerminalPage from './TerminalPage';
import TerminalList from './TerminalList';

function PrivateRoute({ children }: { children: React.ReactNode }) {
    const { user, loading } = useAuth();
    if (loading) return <div className="loading-screen">Загрузка...</div>;
    return user ? <>{children}</> : <Navigate to="/login" />;
}

function PublicRoute({ children }: { children: React.ReactNode }) {
    const { user, loading } = useAuth();
    if (loading) return <div className="loading-screen">Загрузка...</div>;
    return user ? <Navigate to="/" /> : <>{children}</>;
}

export default function App() {
    return (
        <BrowserRouter>
            <AuthProvider>
                <Routes>
                    <Route path="/login" element={<PublicRoute><Login /></PublicRoute>} />
                    <Route path="/"      element={<PrivateRoute><Dashboard /></PrivateRoute>} />
                    <Route path="/servers"     element={<PrivateRoute><Servers /></PrivateRoute>} />
                    <Route path="/servers/:id" element={<PrivateRoute><ServerDetail /></PrivateRoute>} />
                    <Route path="/terminal"     element={<PrivateRoute><TerminalList /></PrivateRoute>} />
                    <Route path="/terminal/:id" element={<PrivateRoute><TerminalPage /></PrivateRoute>} />
                    <Route path="/alerts"   element={<PrivateRoute><Alerts /></PrivateRoute>} />
                    <Route path="/settings" element={<PrivateRoute><SettingsPage /></PrivateRoute>} />
                    <Route path="*" element={<Navigate to="/" />} />
                </Routes>
            </AuthProvider>
        </BrowserRouter>
    );
}
